module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "javacode"
  }, [_c('pre', {
    staticClass: "quelltext"
  }, [_c('code', [_vm._v(_vm._s(_vm.java))]), _vm._v("\n        ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c97242c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/JavaCode.vue
// module id = 25
// module chunks = 0